<template>
  <div class="box">
    <video id="zhijiaVideo" class="player" controls autoplay muted></video>

    <div class="btns-box">
      <div>{{ online ? "设备在线" : "设备离线" }}</div>
      <div id="videoMap"></div>

      <div class="btns" v-if="online">
        <div v-for="item in channels" :key="item.channel">
          <el-button @click="play(item.channel)">{{ item.label }}</el-button>
          <el-button :loading="recordLoading[item.channel]" @click="recording(item.channel)">录像</el-button>
          <el-button :loading="captureLoading[item.channel]" @click="capturePic(item.channel)">抓拍</el-button>
        </div>
      </div>

      <div>
        <el-button @click="telTip(1)">疲劳提醒</el-button>
        <el-button @click="telTip(2)">不要玩手机提醒</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { tipDriverHaveRest, getDriverLocation } from "@/api";
import {
  zhijiaOnline,
  zhijiaLive,
  zhijiaCapture,
  zhijiaCaptures,
  downloadZhijiaClip
} from "@/api/zhijia_monitor";

function pad(num) {
  return num < 10 ? `0${num}` : `${num}`;
}

function formatDateTime(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(
    date.getMinutes()
  )}:${pad(date.getSeconds())}`;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export default {
  data() {
    return {
      deviceNo: "",
      driverId: "",
      online: false,
      flvPlayer: null,
      playingChannel: null,
      captureLoading: {},
      recordLoading: {},
      idleTime: 0,
      timer: null,
      locationTimer: null,
      instance: null,
      carMarker: null,
      channels: [
        { channel: 1, label: "车外" },
        { channel: 3, label: "车内" },
        { channel: 2, label: "副驾" },
        { channel: 4, label: "主驾" }
      ]
    };
  },

  mounted() {
    this.deviceNo = this.$route.query.deviceNo;
    this.driverId = this.$route.query.driverId;
    this.initMap();
    this.refreshOnline();
    this.getLocation();
    this.locationMonitor();
    this.checkIdleTime();
  },

  beforeDestroy() {
    this.destroyPlayer();
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.locationTimer) {
      clearInterval(this.locationTimer);
    }
    document.removeEventListener("mousemove", this.updateIdleTime);
    document.removeEventListener("keypress", this.updateIdleTime);
  },

  methods: {
    refreshOnline() {
      zhijiaOnline(this.deviceNo).then((res) => {
        this.online = !!(res.data && res.data.online);
      });
    },

    play(channel) {
      this.destroyPlayer();
      this.playingChannel = channel;
      zhijiaLive(this.deviceNo, channel).then((res) => {
        const httpFlv = res.data && res.data.httpFlv;
        if (!httpFlv) {
          this.$message.error("没有可用的直播地址");
          return;
        }
        if (this.playingChannel !== channel) {
          return;
        }
        this.startFlv(httpFlv);
      });
    },

    startFlv(url) {
      if (!flvjs.isSupported()) {
        this.$message.error("当前浏览器不支持 FLV 播放");
        return;
      }
      const videoElement = document.getElementById("zhijiaVideo");
      this.flvPlayer = flvjs.createPlayer({ type: "flv", url, isLive: true });
      this.flvPlayer.attachMediaElement(videoElement);
      this.flvPlayer.load();
      this.flvPlayer.play();
    },

    destroyPlayer() {
      if (!this.flvPlayer) {
        return;
      }
      this.flvPlayer.pause();
      this.flvPlayer.unload();
      this.flvPlayer.detachMediaElement();
      this.flvPlayer.destroy();
      this.flvPlayer = null;
    },

    async capturePic(channel) {
      this.$set(this.captureLoading, channel, true);
      const start = formatDateTime(new Date(Date.now() - 60 * 1000));
      try {
        await zhijiaCapture(this.deviceNo, channel);
        const endLimit = Date.now() + 20 * 1000;
        while (Date.now() < endLimit) {
          await sleep(2000);
          const res = await zhijiaCaptures(this.deviceNo, channel, start, formatDateTime(new Date()));
          const files = res.data || [];
          const file = files.find((item) => item && item.fileUrl);
          if (file) {
            window.open(file.fileUrl, "_blank");
            return;
          }
        }
        this.$message.warning("抓拍指令已下发，图片尚未上传");
      } catch (e) {
        // 请求失败时拦截器已提示
      } finally {
        this.$set(this.captureLoading, channel, false);
      }
    },

    async recording(channel) {
      this.$set(this.recordLoading, channel, true);
      const end = new Date();
      const start = new Date(end.getTime() - 60 * 1000);
      try {
        const url = await downloadZhijiaClip(this.deviceNo, channel, formatDateTime(start), formatDateTime(end));
        if (url) {
          window.open(url, "_blank");
        } else {
          this.$message.warning("录像下载尚未完成");
        }
      } catch (e) {
        // 请求失败时拦截器已提示
      } finally {
        this.$set(this.recordLoading, channel, false);
      }
    },

    telTip(type) {
      tipDriverHaveRest(this.driverId, type);
    },

    locationMonitor() {
      this.locationTimer = setInterval(() => {
        this.getLocation();
      }, 5000);
    },

    getLocation() {
      if (!this.driverId) {
        return;
      }
      getDriverLocation(this.driverId).then((res) => {
        const location = (res.data && res.data.location) || {};
        if (location.lng && location.lat) {
          this.renderCarPosition(location);
        }
      });
    },

    renderCarPosition(location) {
      if (!this.instance) {
        return;
      }
      const carMarker = new AMap.Marker({
        position: new AMap.LngLat(location.lng, location.lat),
        label: {
          direction: "top",
          content: `<div>${location.address || ""}</div>`
        },
        icon: new AMap.Icon({
          size: new AMap.Size(20, 40),
          image: "https://a.amap.com/jsapi_demos/static/demo-center-v2/car.png",
          imageSize: new AMap.Size(20, 40)
        }),
        offset: new AMap.Pixel(-10, -20)
      });
      if (this.carMarker) {
        this.instance.remove(this.carMarker);
      }
      this.carMarker = carMarker;
      this.instance.add(carMarker);
      this.instance.setFitView([carMarker]);
    },

    initMap() {
      this.instance = new AMap.Map("videoMap", {
        resizeEnable: true,
        dragEnable: true,
        zoom: 14
      });
    },

    checkIdleTime() {
      this.idleTime = 0;
      this.timer = setInterval(() => {
        this.idleTime += 1000;
        if (this.idleTime >= 3 * 60 * 1000) {
          clearInterval(this.timer);
          this.destroyPlayer();
          window.close();
        }
      }, 1000);
      document.addEventListener("mousemove", this.updateIdleTime);
      document.addEventListener("keypress", this.updateIdleTime);
    },

    updateIdleTime() {
      this.idleTime = 0;
    }
  }
};
</script>

<style scoped lang="less">
.box {
  display: flex;
  height: 100vh;
  background: #111;
}

.player {
  flex: 1;
  width: 70%;
  height: 100%;
  background: #000;
}

.btns-box {
  width: 360px;
  padding: 16px;
  color: #fff;
  background: #1f1f1f;
}

#videoMap {
  width: 100%;
  height: 240px;
  margin: 12px 0;
}

.btns > div {
  margin-bottom: 10px;
}
</style>
